'use client';
import BasicLink from 'core/BasicLink';
import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import NewProjectContainer from 'shared/sections/NewProjectContainer';

import { links, listNewProjects } from '~/components/features/cases/MainPage/constants';

import cn from './style.module.sass';

export default function MainPage(props: { id: string }) {
    const getCasesById = () => {
        if (props.id === 'all') {
            return listNewProjects;
        }

        return listNewProjects.filter(element => element.keys?.includes(props.id));
    };

    return (
        <ScrollAnimation>
            <FullWrapper caseName={cn.projects}>
                <h1 className={cn['projects-title']}>Кейсы</h1>
                <div className={cn['projects__links']}>
                    {links.map(({ id, title, href }) => (
                        <BasicLink key={id} href={href}>
                            <span
                                className={`${cn['projects__link']} ${
                                    id === props.id ? cn['projects__link--active'] : ''
                                }`}
                            >
                                {title}
                            </span>
                        </BasicLink>
                    ))}
                </div>
            </FullWrapper>
            <NewProjectContainer currentList={getCasesById()} />
        </ScrollAnimation>
    );
}
